export const LocIcon = (props) => {
  const svgStyle = {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5px",
  };
  return (
    // <svg
    //   {...props}
    //   style={svgStyle}
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="14.561"
    //   height="14"
    //   viewBox="0 0 14.561 14"
    // >
    //   <path
    //     d="m0 0 6 6-6 6"
    //     transform="rotate(-90 5.5 4)"
    //     data-name="Group 9658"
    //   />
    // </svg>
    <svg
      {...props}
      style={svgStyle}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g transform="translate(-46.139 -14)" data-name="Group 20596">
        <path
          data-name="Path 60816"
          d="M243.681 377.858a1.649 1.649 0 0 1 1.649 1.649h0a1.649 1.649 0 0 1-1.649 1.649h-5.841"
          transform="translate(-182.407 -347.678)"
          style={{fill:"none",stroke:"#384853",strokeLinecap:"round",strokeLinejoin:"round",strokeMiterlimit:10,strokeWidth:"2px"}}
        />
        <path
          data-name="Path 60817"
          d="M116.769 356.641h13.34a2.536 2.536 0 0 0 1.832-.782l4.6-4.809a1.649 1.649 0 0 0 0-2.332h0a1.649 1.649 0 0 0-2.332 0l-3.027 3.027c0-.045.006-.09.006-.136a1.649 1.649 0 0 0-1.649-1.649h-1.688a4.807 4.807 0 0 1-2.154-.51h0a4.807 4.807 0 0 0-2.154-.51h-.755a5.18 5.18 0 0 0-2.125.456l-.514.231a5.18 5.18 0 0 1-2.125.456h-1.381z"
          transform="translate(-68.268 -319.779)"
          style={{fill:"none",stroke:"#384853",strokeLinecap:"round",strokeLinejoin:"round",strokeMiterlimit:10,strokeWidth:"2px"}}
        />
        <circle
          data-name="Ellipse 1154"
          cx="4.932"
          cy="4.932"
          r="4.932"
          transform="translate(54.202 15)"
          style={{fill:"none",stroke:"#384853",strokeLinecap:"round",strokeLinejoin:"round",strokeMiterlimit:10,strokeWidth:"2px"}}
        />
      </g>
    </svg>
  );
};
